<template>
  <div :class="$style.container">
    <div v-for="(emojiList, category) in viewData" :key="category">
      <div :class="$style.title">{{ category }}</div>
      <div :class="$style.emojis">
        <span
          v-for="emojiData in emojiList"
          :key="emojiData.name"
          @click="$emit('insert', emojiData.text)"
          :title="emojiData.name"
          :class="$style.item"
          v-close-popover
          >{{ emojiData.text }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import emojiData from 'unicode-emoji-meta'
import { groupBy } from 'lodash'
import Fuse from 'fuse.js'

export default {
  name: 'emoji',
  props: {
    query: String
  },
  computed: {
    viewData () {
      let data = emojiData
      if (this.query) {
        const list = Object.values(emojiData)
        const fuse = new Fuse(list, {
          keys: ['name', 'tags']
        })
        data = fuse.search(this.query)
      }
      return groupBy(data, 'category')
    }
  }
}
</script>

<style module lang="scss">
.container {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.title {
  padding: 6px 12px;
  font-size: 12px;
  color: $text-mid-dark;
}
.emojis {
  display: flex;
  flex-wrap: wrap;
}
.item {
  flex-basis: 14.28%; // 16.6%;
  font-size: 28px;
  cursor: pointer;
  text-align: center;
  transition: all 0.1s;
  margin-bottom: 2px;
  &:hover {
    transform: scale(1.1);
    z-index: 10;
  }
}
</style>
